import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarClockIcon, CheckCircle2Icon, PhoneIcon, ScanSearchIcon } from 'lucide-react';
import { business } from '../../data/business';
import { copy } from '../../data/copy';
import { useLanguage } from '../../contexts/LanguageContext';
import { SectionHeading } from '../SectionHeading';
const icons = [CalendarClockIcon, ScanSearchIcon, CheckCircle2Icon];
export function ProcessSteps() {
  const {
    t
  } = useLanguage();
  return <section className="bg-navy-50 py-16 sm:py-20" data-id="element-263" data-mp="30xh0w3uuakm9">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-264" data-mp="30vw6qfcft3ox">
        <div data-id="element-265" data-mp="2vynpqi30z5p9">
          <SectionHeading title={t(copy.process.title)} description={t(copy.process.intro)} data-id="element-266" data-mp="2vw1heg8b8m5z" />
          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-267" data-mp="2mx6at31cta25">
            <Link to="/contact" className="flex min-h-[48px] items-center justify-center rounded-md bg-navy-900 px-6 font-bold text-white transition-colors duration-150 ease-smooth hover:bg-navy-800" data-id="element-268" data-mp="2mziov53zr09x">
              {t(copy.cta.bookNow)}
            </Link>
            <a href={business.phoneHref} className="flex min-h-[48px] items-center justify-center gap-2 rounded-md border border-navy-300 px-6 font-bold text-navy-900 transition-colors duration-150 ease-smooth hover:bg-white" data-id="element-269" data-mp="jzq93nc8xk5a">
              <PhoneIcon width={17} height={17} aria-hidden="true" data-id="element-270" data-mp="ywqwjenemsxy" />
              {t(copy.cta.call)} {business.phoneDisplay}
            </a>
          </div>
        </div>

        <ol className="relative" data-id="element-271" data-mp="oxrx8moj49nm">
          <span aria-hidden="true" className="absolute bottom-6 left-[23px] top-6 w-px bg-navy-200" data-id="element-272" data-mp="owqdlttg6eua" />
          {copy.process.steps.map((step, index) => {
          const Icon = icons[index];
          return <li key={step.title.en} className="relative flex gap-5 pb-9 last:pb-0" data-id="element-273" data-mp="3emtwzewjmsg9" data-mpi={index}>
                <span className="relative z-10 inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-navy-900 text-gold-400 ring-4 ring-navy-50" data-id="element-274" data-mp="2ujo0ew2wlwxs">
                  <Icon width={22} height={22} aria-hidden="true" data-id="element-275" data-mp="2ls5m6qpipr7c" />
                </span>
                <div className="pt-1" data-id="element-276" data-mp="2gtc92ze5827p">
                  <p className="text-sm font-bold uppercase tracking-wide text-navy-500" data-id="element-277" data-mp="2gs9jqvwgy7tw">
                    {t(copy.process.stepLabel)} {index + 1}
                  </p>
                  <h3 className="mt-1 font-display text-xl font-bold text-navy-900" data-id="element-278" data-mp="26vejo8kjrzdi">
                    {t(step.title)}
                  </h3>
                  <p className="mt-2 max-w-xl leading-relaxed text-navy-600" data-id="element-279" data-mp="22u33etnkcqhz">
                    {t(step.body)}
                  </p>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}